import {Chip} from '@mui/material';
import React, {useEffect, useRef, useState} from 'react';
import './ThinkingChip.scss';
import {t} from 'i18next';

interface ThinkingChipProps {
  visible: boolean;
}

const ADJUSTED_WIDTH = 5; // in px
const PX_REM_RATIO = 16;
const ANIMATION_INTERVAL = 450; // in ms
const MAX_THINKING_ANIMATION_INDEX = 3;

const ThinkingChip: React.FC<ThinkingChipProps> = ({visible}) => {
  const [thinkingText, setThinkingText] = useState('');
  const [thinkingChipWidth, setThinkingChipWidth] = useState(0); // in rem
  const thinkingAnimationIndex = useRef(0);

  useEffect(() => {
    if (!visible) return;
    const measurmentDiv = document.createElement('div');
    measurmentDiv.style.position = 'absolute';
    measurmentDiv.style.visibility = 'hidden';
    measurmentDiv.style.whiteSpace = 'nowrap';
    measurmentDiv.innerText = `${t('ai.investigate.chatPanel.thinking')} ...`;
    document.body.appendChild(measurmentDiv);
    setThinkingChipWidth(
      (measurmentDiv.offsetWidth + ADJUSTED_WIDTH) / PX_REM_RATIO
    );
    document.body.removeChild(measurmentDiv);
  }, [visible]);

  useEffect(() => {
    if (!visible) {
      setThinkingText('');
      thinkingAnimationIndex.current = 0;
      return;
    }
    const interval = setInterval(() => {
      setThinkingText(
        `${t('ai.investigate.chatPanel.thinking')} ${'.'.repeat(thinkingAnimationIndex.current)}`
      );
      thinkingAnimationIndex.current >= MAX_THINKING_ANIMATION_INDEX
        ? (thinkingAnimationIndex.current = 0)
        : thinkingAnimationIndex.current++;
    }, ANIMATION_INTERVAL);
    return () => clearInterval(interval);
  }, [visible]);
  return (
    <Chip
      data-testid="thinking-chip"
      label={thinkingText}
      size="small"
      className="thinking-chip typo-text label4_size"
      sx={{width: `${thinkingChipWidth}rem`}}
    />
  );
};

export default ThinkingChip;
